import React from 'react';

export default function RefreshRegion({ loading, children, dimWhileLoading = true }) {
  return (
    <section aria-busy={loading}>
      <div role="status" className="h-6 text-sm text-blue-600">
        {loading ? 'Updating results…' : ''}
      </div>
      <fieldset
        disabled={loading}
        className={`m-0 min-w-0 border-0 p-0 transition-opacity duration-150 motion-reduce:transition-none ${loading ? `${dimWhileLoading ? 'opacity-50' : 'opacity-100'} pointer-events-none` : 'opacity-100'}`}
      >
        {children}
      </fieldset>
    </section>
  );
}
